module.exports = __webpack_public_path__ + "static/media/BC_Jacquard_Accademia_DK Chocolate_LT Grey.519bc482.png";